<ng-template #addRfiDialog>
  <div
    class="flex justify-between items-center gap-8 sticky top-0 !bg-[#dee2e6] p-6"
  >
    <div class="flex justify-start items-center gap-8 top-0 !bg-[#dee2e6]">
      <h3 class="header-title">Add Assignee</h3>
      <span
        class="!ml-[10px] bg-[#F4F4F4] px-[20px] rounded-[0.625rem] text-[14px] text-[#343A40] roboto font-semibold"
      >
        RFI #001RFI-2024</span
      >
    </div>
    <!-- Close Icon -->
    <div
      style="position: absolute; top: 10px; right: 36px; z-index: 50"
      (click)="closeDialog()"
    >
      <img
        src="assets/icons/cross-icon.svg"
        alt="cross icon"
        class="cursor-pointer !fixed"
      />
    </div>
  </div>
  <div class="inline-dialog">
    <form [formGroup]="rfiForm" (ngSubmit)="createRFI()">
      <div class="">
        <!-- Organization Dropdown -->
        <div class="flex justify-between gap-5">
          <mat-form-field class="w-1/2" appearance="outline">
            <mat-label>Select Organization</mat-label>
            <mat-select formControlName="orgId" multiple>
              <mat-option *ngFor="let org of allOrganizations" [value]="org.id">
                {{ org.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="orgIdControl?.invalid && orgIdControl?.touched">
              Organization selection is required.
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Due date -->
        <!-- <mat-form-field class="w-full" appearance="outline">
          <mat-label>Due Date</mat-label>
          <input
            matInput
            [matDatepicker]="responseDate"
            formControlName="responseDate"
            placeholder="Due Date"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="responseDate"
          ></mat-datepicker-toggle>
          <mat-datepicker #responseDate startView="year"></mat-datepicker>
        </mat-form-field> -->
        <!-- Clarification -->
        <!-- <div class="col-span-2">
          <app-rich-textEditor
            (contentChange)="addClarification($event)"
            [richTextValue]="rfiForm.get('clarification')?.value"
            [placeHolder]="'Enter Clarification'"
            [label]="'Request for Information / Clarification'"
          ></app-rich-textEditor>
          <mat-error
            *ngIf="
              rfiForm.get('clarification')?.invalid &&
              rfiForm.get('clarification')?.touched
            "
          >
            Clarification is required
          </mat-error>
        </div> -->

        <!-- Attachments -->
        <!-- <div class="col-span-2 mt-[20px]">
          <label class="block text-sm font-medium text-gray-700 mb-1"
            >Attachments</label
          >

          <div class="flex flex-col items-start">
            <div class="bg-[#f7f6fb] w-[100%]">
              <div
                class="flex h-[122px] flex-col items-center justify-center p-6 border-2 border-dashed hover:bg-orange-500 hover:bg-opacity-10 border-gray-300 cursor-pointer transition-all duration-300"
                (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)"
                (drop)="onDrop($event)"
                [class.bg-blue-50]="isDragging"
              >
                <button
                  type="button"
                  class="bg-[#D9D9D9] text-[#21252A] px-4 py-2 rounded mt-[25px] hover:bg-[#D9D9D9] focus:outline-none"
                  (click)="fileInputImage.click()"
                >
                  Attach File
                </button>
                <input
                  type="file"
                  #fileInputImage
                  (change)="onFileUpload($event, false)"
                  multiple
                  hidden
                />
                <p class="text-lg font-normal text-[#21252A]">Drag & Drop</p>
              </div>
            </div>
            <div class="flex flex-col">
              <div
                *ngFor="
                  let file of rfiForm.get('attachments')?.value;
                  let i = index
                "
                class="flex items-start mt-[11px]"
              >
                <div class="flex justify-start items-center">
                  <div
                    class="relative ml-[5px] w-[1.5rem] h-[1.5rem] overflow-hidden"
                  >
                    <img
                      [src]="getFileIcon(file)"
                      alt="File Preview"
                      class="object-cover w-auto h-[100%] cursor-pointer"
                    />
                  </div>
                </div>
                <span
                  style="
                    color: black;
                    text-align: left;
                    font-size: 18px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    display: inline-block;
                    overflow: visible;
                    margin-left: 10px;
                    margin-top: 5px;
                  "
                >
                  {{ file.name }}
                </span>

                <img
                  (click)="removeAttachment(i)"
                  src="assets/icons/trash.svg"
                  alt="trash"
                  class="object-cover w-auto h-[17px] cursor-pointer ml-[8px] mt-[8px]"
                />
              </div>
            </div>
          </div>
        </div> -->
      </div>

      <!-- Form Actions -->
      <div class="dialog-actions mt-[40px] sticky bottom-0 left-0 !bg-[white]">
        <div class="w-full flex justify-end items-center">
          <button
            (click)="handleCancel()"
            type="button"
            class="cancel-btn mr-[10px] !font-medium"
          >
            Cancel
          </button>
          <button class="submit-btn" type="submit">Submit</button>
        </div>
      </div>
    </form>
  </div>
</ng-template>
